import { useEffect } from 'react';
import {
  APP_DOCUMENT_TITLE,
  buildDocumentTitle,
} from '@client/helpers/document-title.helpers';
import { useIsProjectList } from '@client/hooks/use-router.hooks';
import { useProjectState } from '@client/store/project';

/**
 * Sync the browser tab title with project list / open project context.
 */
export const useDocumentTitle = (): void => {
  const isProjectList = useIsProjectList();
  const { project, isLoading } = useProjectState('project', 'isLoading');

  useEffect(() => {
    document.title = buildDocumentTitle({
      isProjectList,
      projectName: project.name,
      isLoadingProject: isLoading && !isProjectList,
    });

    return () => {
      document.title = APP_DOCUMENT_TITLE;
    };
  }, [isProjectList, project.name, isLoading]);
};
